export const featuresText = [
  {
    text: 'Enterprise/Agency Partner Program',
    tooltip:
      'Unlock exclusive partnership benefits designed to maximize the value and reach of your enterprise. Enjoy co-marketing opportunities, shared resources, and priority support.',
  },
  {
    text: 'Enterprise Dashboard/Back-office',
    tooltip:
      'Gain access to an advanced dashboard with comprehensive controls for managing your clients, users, and data all in one place.',
  },
  {
    text: 'White-Label',
    tooltip:
      'Customize the platform with your branding—add your logo, domain, and company colors for a fully branded experience.',
  },
  {
    text: 'Multi-user Management',
    tooltip:
      'Easily manage multiple users across your organization with advanced permissions and role-based access controls.',
  },
  {
    text: 'Early Access to Beta Features',
    tooltip:
      'Be the first to test and implement cutting-edge features before they’re officially released to the public.',
  },
  {
    text: 'Dedicated Account Manager',
    tooltip:
      'Enjoy personalized support from your dedicated account manager, ensuring your enterprise gets the most out of our platform.',
  },
];
